export default "__VITE_ASSET__Cx16iLjD__"